import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';




import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2025 } from '../SchoolProgram2023/components';


const GitaDharaClass2 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2025}/home/events-activities/school-programs/GitaDhara2/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/school-programs/GitaDhara2/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/school-programs/GitaDhara2/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/school-programs/GitaDhara2/4.webp`;

   
    const photos = [
      
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        }, 
          {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        }

    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                               Gita Dhara Value Sessions
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                               Class: 2    Date: 17 December 2025  <br />
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “You are what you believe in. You become that which you believe you can become.”

                            <br />
                            </Typography> */}

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                The students of Class 2 participated in an enchanting Gita Dhara value session conducted  on Wednesday, 17 December 2025 by Ms. Sunitha Rajesh, a well-experienced academician known for chanting Bhagavad Gita shlokas and teaching moral stories across various schools in Bengaluru.  
                                <br></br>
                                Ms. Sunitha Rajesh briefed the students on the importance of shloka chanting and explained its positive effects on the body and mind. She introduced them to the author of the Bhagavad Gita, the number of chapters, the Dashavatara and the important characters of the Mahabharata in a simple and engaging manner.
                                <br></br>
                                She also shared valuable insights from the works of renowned Kannada poet D. V. G. Gundappa, emphasising his message that children should behave according to their age, speak thoughtfully, remain humble and grounded.
                                <br></br>
                                Under her guidance, the students enthusiastically recited shlokas. She made their meanings simple and understandable.
                                <br></br>
                                She further enriched the session by narrating a few moral stories. The session was highly interactive, with students actively participating and making the learning experience meaningful.
                                <br></br>
                                Ms. Sunitha Rajesh concluded the session with an inspiring message :
                                <strong>
                                “Good thoughts lead to good speech and good actions. Always listen good, think good and act good.”
                                </strong>
                                <br></br>
                                This enriching session left a lasting impression on the young minds.
                                </Typography>
                                <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “You are what you believe in. You become that which you believe you can become.”

                            <br />
                            </Typography>
                            </Box>
                             <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2025/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default GitaDharaClass2;